export default __webpack_public_path__ + "static/media/Thug's Straps of Creeping Death.5a0ff684.jpg";